import React from "react";

// Comic action word: BOOM, POW, SLAP, HEAL, KO
export const ComicWord = ({ word, color = "#FFD700", rotate = -6, size = "4xl" }) => {
  return (
    <span
      className={`font-display inline-block px-4 py-1 border-4 border-black cb-shadow text-${size}`}
      style={{
        background: color,
        transform: `rotate(${rotate}deg)`,
        textShadow: "3px 3px 0 #000",
        WebkitTextStroke: "1px #000",
      }}
    >
      {word}
    </span>
  );
};

export default ComicWord;
